/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { MrfiktivHttpClientProvider } from "../../mrfiktiv-http-client.provider";
import {
  MrfiktivFleetInvoiceControllerGetAllParamsGen,
  MrfiktivMultipleIdsDtoOptionalGen
} from "../../v1/data-contracts";
import { FleetInvoices } from "../../v1/FleetInvoices";

export class InvoiceFleetService {
  /**
   * The proxy.
   */
  proxy: FleetInvoices;

  /**
   * @class Initialize ReportMeService
   */
  constructor(clientProvider: MrfiktivHttpClientProvider) {
    this.proxy = new FleetInvoices(clientProvider.client());
  }

  async findAll(query: MrfiktivFleetInvoiceControllerGetAllParamsGen, data: MrfiktivMultipleIdsDtoOptionalGen) {
    return (await this.proxy.fleetInvoiceControllerGetAllPost(query, data)).data;
  }

  findOne(partnerId: string, fleetId: string, id: string) {
    return this.proxy.fleetInvoiceControllerGetOne(partnerId, fleetId, id);
  }
}

export default new InvoiceFleetService(new MrfiktivHttpClientProvider());
